import { useState } from "react";
import { columnsConfig } from "./reportColumns";
import ReportFilters from "./subComponents/reportFilter";
import ReportTable from "./subComponents/reportTable";

const DetailedSalesReport = () => {
  const [filterInputs, setFilterInputs] = useState({
    fromDate: "",
    toDate: ""
  });

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ""
  });

  const handleApplyFilters = () => {
    setFilters(filterInputs);
  };

  const handleResetFilters = () => {
    const empty = { fromDate: "", toDate: "" };
    setFilterInputs(empty);
    setFilters(empty);
  };

  return (
    <>
      <ReportFilters
        filters={filterInputs}
        setFilters={setFilterInputs}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
      <ReportTable
        title="Detailed Sales Report"
        endpoint="Vyapar/SaleInvoice/detailed-sales-report"
        columns={columnsConfig.detailedSalesReport}
        filters={filters}
      />
    </>
  );
};

export default DetailedSalesReport;